import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import allReducers from './reducers';

const initialState = {};

// MEMOIZED STORE STORAGE: Prevents global namespace pollution while keeping instantiation isolated
let memoizedStore = null;

/**
 * LAZY STORE INITIALIZER
 * Defers the expensive combined reducer tree compilation, initial state allocation,
 * and Redux DevTools middleware bootstrap sequence until the React root tree triggers its initial lifecycle mount.
 */
function getStore() {
  if (!memoizedStore) {
    const middleware = [thunk];
    
    // SAFE PRODUCTION GUARD: Avoids executing third-party engine checks during early evaluation phases
    const devTools = (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__)
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : function (a) { return a; };

    memoizedStore = createStore(
      allReducers,
      initialState,
      compose(applyMiddleware(...middleware), devTools)
    );
  }
  return memoizedStore;
}

/**
 * ES5 RECOMPONENT FACADE WRAPPER
 * Avoids ES6 Proxies to maintain 100% runtime compatibility with IE11 polyfill layers,
 * while successfully trapping all top-level entry point requests from <Provider>.
 */
const mainstore = {
  dispatch: function (action) { 
    return getStore().dispatch(action); 
  },
  subscribe: function (listener) { 
    return getStore().subscribe(listener); 
  },
  getState: function () { 
    return getStore().getState(); 
  },
  replaceReducer: function (nextReducer) { 
    return getStore().replaceReducer(nextReducer); 
  }
};

if (typeof Symbol !== 'undefined' && Symbol.observable) {
  mainstore[Symbol.observable] = function () {
    return getStore()[Symbol.observable]();
  };
}

export default mainstore;